import { Roles } from 'api/tokenStorage';

const isSafeReturnPath = (path: string): boolean =>
  path.startsWith('/') && !path.startsWith('//');

/** Preferred role id from returnTo path (dual-role login). */
export function preferredRoleFromReturnTo(returnTo?: string | null): number | null {
  const path = returnTo?.trim();
  if (!path || !isSafeReturnPath(path)) {
    return null;
  }
  if (path.startsWith('/teacher') || path.startsWith('/passport-confirm')) {
    return Roles.tutor;
  }
  if (path.startsWith('/profile')) {
    return Roles.student;
  }
  return null;
}

/** Role implied by the post-login destination (keeps cookie and RoleGuard in sync). */
export function preferredRoleFromPath(path?: string | null): number | null {
  return preferredRoleFromReturnTo(path);
}

/** Куда перенаправить после входа: учитываем returnTo/from и роль пользователя. */
export function resolvePostLoginPath(
  roles: number[],
  returnTo?: string | null,
): string {
  const hasTutor = roles.includes(Roles.tutor);
  const hasStudent = roles.includes(Roles.student);
  const normalizedReturn = returnTo?.trim();

  if (normalizedReturn && isSafeReturnPath(normalizedReturn)) {
    if (
      hasTutor &&
      (normalizedReturn.startsWith('/teacher') ||
        normalizedReturn.startsWith('/passport-confirm'))
    ) {
      return normalizedReturn;
    }
    if (hasStudent && normalizedReturn.startsWith('/profile')) {
      return normalizedReturn;
    }
  }

  if (hasTutor && !hasStudent) return '/teacher';
  if (hasStudent && !hasTutor) return '/profile/tasks';
  if (hasTutor) return '/teacher';
  if (hasStudent) return '/profile/tasks';
  return '/login';
}

/**
 * Resolve destination + the active role cookie that must match it.
 * Prevents RoleGuard loops when roles[0] is student but default home is /teacher.
 */
export function resolvePostLoginNavigation(
  roles: number[],
  returnTo?: string | null,
): { path: string; preferredRoleId: number | null } {
  const path = resolvePostLoginPath(roles, returnTo);
  const preferredRoleId =
    preferredRoleFromReturnTo(returnTo) ?? preferredRoleFromPath(path);
  return { path, preferredRoleId };
}
